import createIcon from '../../createIcon';

/**
 * @component @name AppRegistration
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA0SDkuNVY4SDEzLjVWNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjUgMTZIMy41VjIwSDcuNVYxNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjUgMTBIMy41VjE0SDcuNVYxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03LjUgNEgzLjVWOEg3LjVWNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMy41IDEyLjQyVjEwSDkuNVYxNEgxMS45MkwxMy41IDEyLjQyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwLjM4IDExLjI5TDE5LjIxIDEwLjEyQzE5LjA1IDkuOTYgMTguNzkgOS45NiAxOC42MyAxMC4xMkwxNy43NSAxMUwxOS41IDEyLjc1TDIwLjM4IDExLjg3QzIwLjU0IDExLjcxIDIwLjU0IDExLjQ1IDIwLjM4IDExLjI5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjUgMTguMjVWMjBIMTIuMjVMMTguOTIgMTMuMzNMMTcuMTcgMTEuNThMMTAuNSAxOC4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOS41IDRIMTUuNVY4SDE5LjVWNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AppRegistration = createIcon('AppRegistration', [
  ['path', { d: 'M13.5 4H9.5V8H13.5V4Z', key: '7wocuh' }],
  ['path', { d: 'M7.5 16H3.5V20H7.5V16Z', key: '1oui29' }],
  ['path', { d: 'M7.5 10H3.5V14H7.5V10Z', key: 'f63oji' }],
  ['path', { d: 'M7.5 4H3.5V8H7.5V4Z', key: 'ilta3n' }],
  ['path', { d: 'M13.5 12.42V10H9.5V14H11.92L13.5 12.42Z', key: '13cl9h' }],
  [
    'path',
    {
      d: 'M20.38 11.29L19.21 10.12C19.05 9.96 18.79 9.96 18.63 10.12L17.75 11L19.5 12.75L20.38 11.87C20.54 11.71 20.54 11.45 20.38 11.29Z',
      key: 'ojh6ax',
    },
  ],
  ['path', { d: 'M10.5 18.25V20H12.25L18.92 13.33L17.17 11.58L10.5 18.25Z', key: '1ks8iv' }],
  ['path', { d: 'M19.5 4H15.5V8H19.5V4Z', key: '1kwrcv' }],
]);

export default AppRegistration;
